var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.75 10C16.75 10.4142 16.4142 10.75 16 10.75L5.93996 10.75L10.0045 14.445C10.311 14.7237 10.3336 15.198 10.055 15.5045C9.77633 15.811 9.30199 15.8336 8.9955 15.555L3.4955 10.555C3.33914 10.4128 3.25 10.2113 3.25 10C3.25 9.7887 3.33914 9.58719 3.4955 9.44505L8.9955 4.44505C9.30199 4.16642 9.77632 4.18901 10.055 4.4955C10.3336 4.80199 10.311 5.27633 10.0045 5.55496L5.93996 9.25001L16 9.25C16.4142 9.25 16.75 9.58579 16.75 10Z",
    fill: "#8D9299"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLeftArrow);
export default __webpack_public_path__ + "static/media/icon-Left-arrow.a2090da90800c7cc39f2346d18a65997.svg";
export { ForwardRef as ReactComponent };